// extracted by mini-css-extract-plugin
export var cardIcon = "_ai-5";
export var cardIconUnframed = "_ai-9";
export var checkboxCard = "_ai-0";
export var checkboxCardSelected = "_ai-4";
export var disabled = "_ai-2";
export var interactive = "_ai-1";
export var outerBorder = "_ai-3";
export var spacerMedium = "_ai-8";
export var spacerSmall = "_ai-7";
export var spacerXsmall = "_ai-6";